exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".sj-question-file-add button{color:#e4e7ed;font-size:73px;padding:0}.sj-question-file-add button:hover{color:#c0c4cc}", "", {"version":3,"sources":["/workspace/src/views/question-editor/packages/sj-question-file/src/SjQuestionFileAdd.vue"],"names":[],"mappings":"AACA,6BAA6B,cAAc,eAAe,SAAS,CAClE,AACD,mCAAmC,aAAa,CAC/C","file":"SjQuestionFileAdd.vue","sourcesContent":["\n.sj-question-file-add button{color:#E4E7ED;font-size:73px;padding:0\n}\n.sj-question-file-add button:hover{color:#C0C4CC\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4501a3c1","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/question-editor/packages/sj-question-file/src/SjQuestionFileAdd.vue
// module id = 1757
// module chunks = 5 6 7 18